'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var cookie = {
  /**
   * 获取cookie的值,不对值进行解码
   * @name hp.cookie.getRaw
   * @param {string} key    目标参数
   */
  getRaw: function getRaw(key) {
    if (cookie._isValidKey(key)) {
      var reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
      var result = reg.exec(document.cookie);
      if (result) {
        return result[2] || null;
      }
    }
    return null;
  },

  /**
   * 获取cookie的值,用decodeURIComponent进行解码
   * @name hp.cookie.get
   * @param {string} key      目标参数
   */
  get: function get(key) {
    var value = cookie.getRaw(key);
    if (typeof value === 'string') {
      value = decodeURIComponent(value);
      return value;
    }
    return null;
  },

  /**
   * 设置cookie的值,不对值进行解码
   * @name hp.cookie.setRaw
   * @param {string} key           目标参数
   * @param {string} value         设置参数值
   */
  setRaw: function setRaw(key, value, options) {
    if (!cookie._isValidKey(key)) {
      return;
    }

    options = options || {};
    // options.path = options.path || "/"; // meizz 20100402 设定一个初始值，方便后续的操作
    // berg 20100409 去掉，因为用户希望默认的path是当前路径，这样和浏览器对cookie的定义也是一致的

    // 计算cookie过期时间
    var _options = options,
        expires = _options.expires;


    if (typeof expires === 'number') {
      expires = new Date(utils.timestamps() + expires * 24 * 60 * 60 * 1000);
    }

    document.cookie = key + '=' + value + (options.path ? '; path=' + options.path : '') + (expires ? '; expires=' + expires.toGMTString() : '') + (options.domain ? '; domain=' + options.domain : '') + (options.secure ? '; secure' : '');
  },

  /**
   * 设置cookie的值,用decodeURIComponent进行解码
   * @name hp.cookie.set
   * @param {string} key           目标参数
   * @param {string} value         设置参数值
   */
  set: function set(key, value, options) {
    cookie.setRaw(key, encodeURIComponent(value), options);
  },

  /**
   * 删除cookie的值
   * @name hp.cookie.remove
   * @param {string} key           目标参数
   */
  remove: function remove(key, options) {
    options = options || {};
    options.expires = new Date(0);
    cookie.setRaw(key, '', options);
  },
  _isValidKey: function _isValidKey(key) {
    return new RegExp('^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$').test(key);
  }
};

exports.default = cookie;


// WEBPACK FOOTER //
// ./lib/cookie.js